module.exports = __webpack_public_path__ + "img/650.d2fa8737.jpg";